"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
let prefix = 'generic';
export const setPrefix = thisPrefix => {
  prefix = thisPrefix;
  return prefix;
};
let store = typeof window === 'undefined' ? null : localStorage;
export const setStore = thisStore => {
  store = thisStore;
  return store;
};
const memoryStore = new Map();

/**
 * @private
 *
 * @description
 * Makes a app specific key from the specified original key.
 */
const makeKey = key => `${prefix}-${key}`;

/**
 * @description
 * Returns whether or not the key exists in the store.
 */
export const storeHas = (key, memory = false) => memory ? memoryStore.has(makeKey(key)) : store.getItem(makeKey(key)) !== null;

/**
 * @description
 * Gets the value at the specified key.
 */
export const storeGet = (key, memory = false) => memory ? memoryStore.get(makeKey(key)) || Object.create(null) : JSON.parse(store.getItem(makeKey(key))) || Object.create(null);

/**
 * @description
 * Puts an Object or String into your defined store.
 */
export const storePut = (key, value, memory = false) => {
  if (memory) {
    memoryStore.set(makeKey(key), value);
    return memoryStore.get(makeKey(key));
  }
  store.setItem(makeKey(key), JSON.stringify(value, (jKey, jValue) => /^\${2}/.test(jKey) ? void 0 : jValue));
  return storeGet(key);
};

/**
 * @description
 * A method that will merge the new value with the current value at the key.
 */
export const storePatch = (key, value) => {
  const currentValue = storeGet(key);
  const removeKeys = Object.entries(value).filter(([_, removeValue]) => removeValue === void 0).map(([removeKey]) => removeKey);
  const newObj = _objectSpread(_objectSpread({}, currentValue), value);
  return storePut(key, Object.keys(newObj).reduce((result, currentKey) => {
    if (removeKeys.includes(currentKey)) {
      delete result[currentKey];
    }
    return result;
  }, newObj));
};

/**
 * @description
 * Deletes the specified key from the store, and returns what it deleted.
 */
export const storeDel = (key, memory = false) => {
  const tmp = storeGet(key, memory);
  if (memory) {
    memoryStore.delete(makeKey(key));
  } else {
    store.removeItem(makeKey(key));
  }
  return tmp;
};

/**
 * @description
 * Deletes all keys from the store.
 */
export const storeDelAll = (memory = false) => {
  const storeToUse = memory ? memoryStore : store;
  storeToUse.clear();
};